<template>
  <div class="wms-order">
    <div class="upload-container">
      <!-- 订单错误记录 -->
      <div class="orderErrRecord">
        <div class="orderErrRecord-container">
          <div class="title">订单错误记录</div>
          <div class="row-head">
            <div class="err-reason-head">错误原因：</div>
            <div class="err-nums-head">错误条数：</div>
          </div>
          <div class="row-body" v-for="(item, index) in orderErrRecordList" :key="index">
            <div class="err-reason-body" :title="item.reason">{{ `${index+1}.${item.reason}` }}</div>
            <div class="err-nums-body">{{ item.nums }}</div>
          </div>
        </div>
        <div class="orderErrRecord-upload-container">
          <el-button class="btn-blue" @click="reimport"
            >重新导入</el-button
          >
        </div>
      </div>
      <!-- 订单导入 -->
      <div class="order-export">
        <div class="title">订单导入</div>
        <div class="order-container">
          <el-select class="white" v-model="warehouseId" placeholder="请选择仓库">
            <el-option
              v-for="item in warehouse"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-select
            class="white"
            v-model="dataSource"
            placeholder="请选择数据来源"
          >
            <el-option
              v-for="item in dataSourceList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-button slot="trigger" class="btn-blue" @click="watch"
            >订单导入</el-button
          >
        </div>
      </div>
      <!-- 操作收入 -->
      <!-- <div class="operating-income">
        <div class="title">操作收入</div>
        <div class="operating">
          <div class="number-count">
            <p class="operating-title">步骤一</p>
            <el-form label-width="30px" :model="ruleForm" :rules="rules" ref="ruleForm">
              <el-form-item prop="warehouseId">
                <el-select
                  class="white"
                  clearable
                  filterable
                  v-model="ruleForm.warehouseId"
                  placeholder="请选择仓库"
                >
                  <el-option
                    v-for="item in warehouse"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item> -->
              <!-- <el-form-item label="项目：" prop="projectsId">
                <el-select
                  class="white"
                  clearable
                  filterable
                  v-model="ruleForm.projectsId"
                  placeholder="请选择项目"
                >
                  <el-option
                    v-for="item in projectList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>-->
              <!-- <el-form-item prop="reportDate">
                <el-date-picker
                  v-model="ruleForm.reportDate"
                  type="date"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-button
                  :disabled="loading2 ? true : false"
                  class="btn-blue"
                  @click="submitForm('ruleForm')"
                >
                  计算单量
                  <i v-show="loading2" class="el-icon-loading el-icon--right"></i>
                </el-button>
              </el-form-item>
            </el-form>
          </div>
          <div class="date-calculate">
            <p class="operating-title">步骤二</p>
            <el-form label-width="30px" :model="ruleForm2" :rules="rules" ref="ruleForm2">
              <el-form-item prop="warehouseId">
                <el-select
                  class="white"
                  clearable
                  filterable
                  v-model="ruleForm2.warehouseId"
                  placeholder="请选择仓库"
                >
                  <el-option
                    v-for="item in warehouse"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="reportDate">
                <el-date-picker
                  v-model="ruleForm2.reportDate"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="选择日期"
                ></el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-button
                  :disabled="loading ? true : false"
                  class="btn-blue"
                  @click="calculate('ruleForm2')"
                >
                  计算收入
                  <i v-show="loading" class="el-icon-loading el-icon--right"></i>
                </el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div> -->
      <!-- 预计快递 -->
      <!-- <div class="express-income">
        <div class="title">预计快递</div>
        <div class="date-calculate">
          <el-date-picker v-model="date" value-format="yyyy-MM-dd" type="date" placeholder="选择日期"></el-date-picker>
          <el-button :disabled="loading4 ? true : false" class="btn-blue" @click="calculateExpress">
            计算
            <i v-show="loading4" class="el-icon-loading el-icon--right"></i>
          </el-button>
        </div>
      </div> -->
    </div>

    <!-- 订单导入 -->
    <el-dialog title="订单导入" top="20vh" :visible.sync="promptingDialog" width="420px" :before-close="closeOrderDown">
      <div class="border"></div>
      <div>
        <div>
          <i class="el-icon-warning"></i>
          <span class="sub-title introduce">功能介绍</span>
        </div>
        <p class="tips">当发生订单缺失时，使用该功能补全数据</p>
      </div>
      <div class="down-tmp">
        <div class="sub-title">
          <span>下载导入模板</span>
          <span class="sub-tips">(点击下载)</span>
        </div>
        <el-button type="text" class="btn-text" @click="downTmp">订单导入模板.xlsx</el-button>
      </div>
      <div>
        <p class="sub-title">订单导入</p>
        <el-upload
          v-if="isUpload"
          :disabled="warehouseId ? false : true"
          v-loading.fullscreen.lock="loading3"
          element-loading-text="文件上传中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
          class="upload"
          ref="upload"
          action="#"
          :show-file-list="false"
          :auto-upload="true"
          :before-upload="uploadExcel"
        >
          <el-button slot="trigger" type="text" class="btn-text"
            >{{uploadTipsName}}</el-button
          >
        </el-upload>
        <div v-else class="upload-tips-container">
          <div class="upload-tips-name">
            {{uploadTipsName}}
            <i class="el-icon-error" @click="removeUploadOrder"></i>
          </div>
        </div>
      </div>
      <div class="dialog-footer">
        <el-button class="btn-white" @click="closeOrderDown"
          >取消</el-button
        >
        <el-button class="btn-blue" @click="confirmOrderDown"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import WMS from "models/wms";
import Expenses from "models/expenses";
const expenses = new Expenses();
const wms = new WMS();
import OperatingIncome from "models/operating-income";
import PersonnelPay from "models/personnel-pay";
const operatingIncome = new OperatingIncome();
const personnelPay = new PersonnelPay();
import ExpressIncome from "models/express-income";
const expressIncome = new ExpressIncome();
import { downLoadFile } from "common/js/util";
export default {
  data() {
    return {
      warehouseId: "",
      warehouse: [],
      loading3: false,
      orderErrRecordList: [],
      dataSource: 1,
      dataSourceList: [
        /* 数据来源列表 */
        {
          id: 1,
          name: "WMS",
        },
        {
          id: 2,
          name: "易仓储",
        },
      ],
      promptingDialog: false,
      uploadTipsName: '点击导入',
      /* wms订单导入的流 */
      formData: null,
      /* 是否导入 */
      isUpload: true,
      /* ------------------------------   以下是操作收入字段 ----------------------------*/
      loading: false,
      loading2: false,
      projectList: [],
      warehouseList: [],
      ruleForm: {
        reportDate: "",
        warehouseId: ""
      },
      ruleForm2: {
        warehouseId: "",
        reportDate: ""
      },
      rules: {
        reportDate: [
          {
            required: true,
            message: "请选择时间",
            trigger: "change"
          }
        ]
      },
      /* -------------------------------  以下是预计快递字段 ---------------------------- */
      date: "",
      loading4: false,
    };
  },
  created() {
    this.getWarehouse();
    this.getprojectList();
    this.initOrderErrRecordList()
  },
  methods: {
    //获取仓库数据
    getWarehouse() {
      expenses.getWarehouseData().then(res => {
        if (res.success) {
          let arr = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            arr.push(obj);
          });
          this.warehouse = arr;
        }
      });
    },
    watch() {
      if (!this.warehouseId) {
        this.$message.error("请选择仓库");
        return
      }
      this.promptingDialog = true
    },
    downTmp() {
      let url
      let fileName
      if (this.dataSource == 1) {
        fileName = 'wms订单导入模板'
        url = 'https://xinge-kz.oss-cn-hangzhou.aliyuncs.com/oa/template/wms%E8%AE%A2%E5%8D%95%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'
      } else {
        fileName = '闲林订单导入模板'
        url = 'https://xinge-kz.oss-cn-hangzhou.aliyuncs.com/oa/template/%E9%97%B2%E6%9E%97%E8%AE%A2%E5%8D%95%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'
      }
      downLoadFile(fileName,url)
    },
    closeOrderDown() {
      this.removeUploadOrder()
      this.promptingDialog = false
    },
    confirmOrderDown() {
      if (this.isUpload) {
        return this.$message.error("请导入文件");
      }
      wms
        .postWMSOrderExcel(this.formData)
        .then(res => {
          if (res.success) {
            this.$message.success("导入成功");
            this.closeOrderDown()
          } else {
            this.$confirm(res.message, "提示", {
              showCancelButton: false,
              confirmButtonText: "确定",
              type: "warning"
            }).then(() => {});
          }
        })
        .catch(res => {
          this.$message.error("导入失败");
        });
    },
    removeUploadOrder() {
      this.formData = null
      this.uploadTipsName = '点击导入'
      this.isUpload = true
    },
    //导入Excel表格
    uploadExcel(file) {
      let formData = new FormData();
      formData.append("file", file);
      formData.append("warehouseId", this.warehouseId);
      formData.append("dataSource", this.dataSource);
      this.formData = formData
      this.uploadTipsName = file.name
      this.isUpload = false
      return false;
    },
    /* 订单错误记录列表 */
    initOrderErrRecordList() {
      wms.getOrderErrRecordList().then(res => {
        if (res.success) {
          let arr = [];
          res.result.map(value => {
            let obj = {};
            obj.nums = value.failureCount;
            obj.reason = value.failureReason;
            arr.push(obj);
          });
          this.orderErrRecordList = arr
        } else {
          this.$message.error(res.message);
        }
      })
    },
    /* 重新导入 */
    reimport() {
      wms.postWmsReimport().then(res => {
        if (res.success) {
          this.$message.success('导入成功');
          this.initOrderErrRecordList()
        } else {
          this.$message.error(res.message);
        }
      })
    },

    /* ---------------------------  以下是操作收入方法  -------------------------- */
    calculate(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loading = true;
          let dateTime = this.ruleForm2.reportDate;
          let warehouseId = this.ruleForm2.warehouseId;
          operatingIncome
            .getPrice(dateTime, warehouseId)
            .then(res => {
              if (res.success) {
                this.loading = false;
                this.$confirm("计算成功", "成功", {
                  confirmButtonText: "确定",
                  showCancelButton: false,
                  type: "success"
                }).then(() => {});
              } else {
                this.$message.error(res.message);
                this.loading = false;
              }
            })
            .catch(() => {
              this.$message.error("计算失败");
              this.loading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //获取名项目数据
    getprojectList() {
      personnelPay.getProjectList().then(res => {
        if (res.success) {
          let arr = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            arr.push(obj);
          });
          this.projectList = arr;
        }
      });
    },
    //单量计算
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loading2 = true;
          let dateTime = this.ruleForm.reportDate;
          let warehouseId = this.ruleForm.warehouseId;
          operatingIncome
            .getNumberCount(dateTime, warehouseId)
            .then(res => {
              if (res.success) {
                this.loading2 = false;
                this.$confirm("计算成功", "成功", {
                  confirmButtonText: "确定",
                  showCancelButton: false,
                  type: "success"
                }).then(() => {});
              } else {
                this.$message.error(res.message);
                this.loading2 = false;
              }
            })
            .catch(() => {
              this.$message.error("计算失败");
              this.loading2 = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    watchCost() {
      if (!this.costUploadForm.warehouseId) {
        this.$message.error("请选择仓库");
      }
    },
    /* ---------------------------- 以下是预计快递方法 ---------------------------- */
    calculateExpress() {
      let dateTime = this.date;
      if (dateTime) {
        this.loading4 = true;
        expressIncome
          .getExpressIncomePice(dateTime)
          .then(res => {
            if (res.success) {
              this.$message.success("计算成功");
              this.loading4 = false;
            } else {
              this.$message.error(res.message);
              this.loading4 = false;
            }
          })
          .catch(() => {
            this.$message.error("计算失败");
            this.loading4 = false;
          });
      } else {
        this.$message.error("请选择日期");
      }
    },
  }
};
</script>
<style lang="scss" scoped>
.wms-order {
  flex: 1;
  display: flex;
  flex-direction: column;
  .upload-container {
    flex: 1;
    .title {
      height: 52px;
      line-height: 52px;
      font-size: 16px;
      font-weight: 400;
      color: #333;
      border-bottom: 1px solid #eee;
      padding-left: 30px;
    }
    .order-export {
      border-radius: 4px;
      background: #fff;
      margin-top: 20px;
      .order-container {
        display: flex;
        flex-direction: column;
        padding: 20px 30px;
        .el-select {
          width: 220px;
          margin-bottom: 16px;
        }
        .el-button {
          width: 102px;
        }
      }
    }
    .orderErrRecord {
      background: #fff;
      border-radius: 4px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding-bottom: 20px;
      .orderErrRecord-container {
        .row-head {
          margin: 20px 0px 18px 30px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          font-size: 14px;
          font-weight: 400;
          color: #666666;
          .err-reason-head {
            width: 300px;
          }
          .err-nums-head {
            width: 100px;
            margin-left: 10px;
          }
        }
        .row-body {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          font-size: 14px;
          font-weight: 400;
          color: #999999;
          margin: 0px 0px 10px 30px;
          .err-reason-body {
            width: 300px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .err-nums-body {
            width: 100px;
            margin-left: 10px;
          }
        }
      }
      .orderErrRecord-upload-container {
        display: flex;
        justify-content: center;
      }
    }
    .operating-income {
      background: #fff;
      margin-top: 20px;
      border-radius: 4px;
      .operating {
        flex: 1;
        display: flex;
        padding-top: 19px;
        .operating-title {
          color: #999999;
          padding-left: 30px;
          margin-bottom: 10px;
        }
        .date-calculate {
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          .el-select,
          .el-date-editor.el-input, 
          .el-date-editor.el-input__inner {
            width: 100%;
          }
          .el-button {
            display: flex;
            align-items: center;
            padding: 0 16px;
          }
          
        }
        .number-count {
          flex: 1;
          .el-date-editor.el-input, 
          .el-date-editor.el-input__inner {
            width: 100%;
          }
        }
        .el-form {
          width: 320px;
          .el-select {
            width: 100%;
          }
        }
      }
    }
    .express-income {
      background: #fff;
      margin-top: 20px;
      border-radius: 4px;
      .date-calculate {
        flex: 1;
        padding: 20px 30px;
        .el-button {
          margin-top: 19px;
          display: flex;
          align-items: center;
          padding: 0 16px;
        }
      }
    }
  }
  .down-tmp {
    margin-bottom: 8px;
  }
  .el-icon-warning {
    font-size: 16px;
    color: #F47A25;
    margin-right: 6px;
    vertical-align: middle;
  }
  .sub-title {
    font-size: 14px;
    font-weight: 400;
    color: #333333;
  }
  .introduce {
    display: inline-block;
  }
  .tips {
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    margin: 11px 0px 21px 0px;
  }
  .upload-tips-container {
    position: relative;
    width: 180px;
    .upload-tips-name {
      height: 30px;
      line-height: 30px;
      margin: 12px 0px;
      color: #2E68EA;
      background: #EBEEF5;
      border-radius: 2px;
      padding-left: 7px;
      box-sizing: border-box;
      overflow : hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      .el-icon-error {
        position: absolute;
        top: -5px;
        right: -8px;
        color: #999999;
        cursor: pointer;
      }
    }
  }
  .sub-tips {
    color: #999999;
  }
  .dialog-footer {
    margin-top: 16px;
    border-top: 1px solid #f7f7f7;
    padding-top: 16px;
    display: flex;
    justify-content: center;
    .btn-white {
      margin-right: 20px;
    }
  }
}
</style>
